import { FC } from "react";
import style from "./divider.module.css";

export type DividerProps = {
  height?: number | string;
  width?: number | string;
  borderSize?: number | string;
  showBorder?: boolean;
};
const Divider: FC<DividerProps> = ({
  height,
  width,
  borderSize,
  showBorder,
}) => {
  return (
    <div
      className={showBorder ? style.border_color : style.no_border}
      style={{
        height: height,
        width: width,
        borderWidth: borderSize,
      }}
    ></div>
  );
};

export default Divider;
